import React, { Component } from "react";
import GraphDisplay from "./GraphDisplay.js";
//GraphDisplay contains the plot and dropdown menus
import {
  layoutPop,
  layoutGDP,
  layoutBudget,
  layoutDiscord,
  layoutFavorability,
  layoutHRT,
  layoutEQT,
  layoutEmployment,
} from "./layouts";
import TabManager from "./TabManager";
import { mapDataToGraphData } from "./datasets";
import { inject, observer } from "mobx-react";

//GraphManager contains all tabs of GraphDisplays
@observer
class GraphManager extends Component {
  render() {
    const { metrics } = this.props.metrics;
    const { start_year, end_year, current_year } = this.props.plotData;

    const plotData = mapDataToGraphData(
      this.props.plotData.plot_data,
      start_year,
      end_year
    );
    const costs_category_list = [];
    for (const item in metrics.costs_data) {
      costs_category_list.push(item);
    }
    return (
      <div className="align-c">
        <TabManager>
          <div label="Budget and Costs">
            <GraphDisplay
              singleY={true}
              budget_data={true}
              plotData={{
                cost_data: metrics.costs_data,
                start_year: start_year,
                end_year: end_year,
                current_year: current_year,
              }}
              plotLayout={layoutBudget}
              categoryList={costs_category_list}
            />
          </div>
          <div label="Population">
            <GraphDisplay
              plotData={plotData.plotData}
              categoryList={plotData.categoryList}
              plotLayout={layoutPop}
            />
          </div>
          <div label="GDP">
            <GraphDisplay
              singleY={true}
              plotData={{
                data: metrics.gdp,
                start_year: start_year,
                end_year: end_year,
                current_year: current_year,
              }}
              title={"GDP"}
              plotLayout={layoutGDP}
            />
          </div>
          <div label="HRX">
            <GraphDisplay
              singleY={true}
              plotData={{
                data: metrics.hrt,
                start_year: start_year,
                end_year: end_year,
                current_year: current_year,
              }}
              title={"HRX"}
              plotLayout={layoutHRT}
            />
              </div>
              <div label="Equity">
                  <GraphDisplay
                      singleY={true}
                      plotData={{
                          data: metrics.eqt,
                          start_year: start_year,
                          end_year: end_year,
                          current_year: current_year,
                      }}
                      title={"Equity"}
                      plotLayout={layoutEQT}
                  />
          </div>
          <div label="Favorability">
            <GraphDisplay
              singleY={true}
              plotData={{
                data: metrics.favorability,
                start_year: start_year,
                end_year: end_year,
                current_year: current_year,
              }}
              title={"Favorability"}
              plotLayout={layoutFavorability}
            />
          </div>
          <div label="Discord">
            <GraphDisplay
              singleY={true}
              plotData={{
                data: metrics.discord,
                start_year: start_year,
                end_year: end_year,
                current_year: current_year,
              }}
              title={"Discord"}
              plotLayout={layoutDiscord}
            />
          </div>
          <div label="Employment">
            <GraphDisplay
              singleY={true}
              plotData={{
                data: metrics.employ,
                start_year: start_year,
                end_year: end_year,
                current_year: current_year,
              }}
              title={"Employ"}
              plotLayout={layoutEmployment}
            />
          </div>
        </TabManager>
      </div>
    );
  }
}

export default inject("metrics")(GraphManager);
